export default "__VITE_ASSET__SqPyUfxt__"